import { FC } from 'react'
import { Link } from 'react-router'

import { INeuroNextLogo } from '../logo.type'


const NeuroNextLogo: FC<INeuroNextLogo> = ({ isDarkTheme }) => {
    const imgSrc = isDarkTheme 
        ? '/tenants/neuronext/img/neuronext_white.svg'
        : '/tenants/neuronext/img/neuronext_black.svg'

    return (
        <Link to="https://neuronext.pl/">
            <img
                src={ imgSrc }
                alt="Neuronext logo"
                width={ 136 }
                height={ 30 }
            />
        </Link>
    )
}

export default NeuroNextLogo
